// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3C8eQ","label":"Completed_label__i2E7q"};